export const LOGIN_ROUTE = '/login';
export const SUPPORT_ROUTE = '/support';
export const MOBILE_SEARCH_ROUTE = '/search';
export const MOBILE_UPDATE_LOCATION_ROUTE = '/search/location';
export const MOBILE_UPDATE_SEARCH_ROUTE = '/search/update';
export const MOBILE_UPDATE_REFERRING_CLINIC_ROUTE = '/referring-clinic/update';
export const REWARDS_ROUTE = '/rewards';
export const REWARDS_REDEEM_ROUTE = '/rewards/redeem';
export const HOME_ROUTE = '/';
export const RESULTS_ROUTE = '/results';
export const SSO_REDIRECT_ROUTE = '/sso-redirect';
